var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgSend01 = function SvgSend01(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5,
    d: "m6.999 9 7-7M7.084 9.22l1.752 4.505c.155.397.232.595.343.653.096.05.211.05.308 0 .11-.057.188-.256.343-.652l4.394-11.259c.14-.358.21-.537.171-.651a.333.333 0 0 0-.21-.21c-.115-.04-.294.03-.652.17L2.274 6.17c-.396.155-.595.232-.652.344a.333.333 0 0 0 0 .307c.058.111.256.189.653.343L6.78 8.915c.08.031.121.047.155.071.03.022.056.048.078.078.024.034.04.074.071.155Z"
  })));
};
export default SvgSend01;